<template>
	<div class="job-results">
		<Loading v-if="loadingApplicants"/>
		<div v-else class="job-results--items">
			<NoMatches
				v-if="applicants.length === 0"
				title="Wir sind auf der Suche nach deinem persönlichen Best-Match."
			>
				<div>
					<b>Wenn du aktuell keine Matches siehst, mach dir keine Sorgen, das ist ganz normal.</b>
				</div>
				<div class="mt-1">
					skilldoo müllt dich nicht mit unpassenden Bewerbungen zu, sondern zeigt dir ausschließlich deine
					Top-Matches. Wir informieren dich per E-Mail, sobald es einen passenden Match gibt.
				</div>
				<div class="mt-3">
					Solltest Du längere Zeit keine passenden Bewerber finden, überlege, ob du die Anforderungen
					verringern möchtest.
				</div>
				<div class="no-matches--content-button-container">
					<Button
						text="Anforderungen ändern"
						icon="checkmark"
						:href="'/kundenbereich/jobs/' + jobProfileListItem.jobProfile.id + '/bearbeiten'"
					/>
				</div>
			</NoMatches>
			<template>
				<Pagination
					v-model="page"
					:page="page"
					:total="meta.total"
					:items-per-page="itemsPerPage"
					class="mb-4"
					@input="loadApplicants"
				/>
				<ListItem
					v-for="applicant in applicants"
					:key="applicant.id"
					:job-profile-list-item="jobProfileListItem"
					:job-id="applicant.jobId"
					:applicant="applicant"
					:permissions="permissions"
					@remove="loadApplicants"
				/>
				<Pagination
					v-model="page"
					:page="page"
					:total="meta.total"
					:items-per-page="itemsPerPage"
					class="mb-4"
					@input="loadApplicants"
				/>
			</template>
		</div>
	</div>
</template>

<script>
import Loading from "@/vue/common/Loading";
import GetList from "@/api/customer/job-profile/applicant/GetList";
import ListItem from "@/vue/customer/job-profile/applicant/ListItem";
import Pagination from "@/vue/common/Pagination"
import {arrayIsNotEmpty} from "@/helper/Array";
import Button from "@/vue/common/Button.vue";
import NoMatches from "@/vue/common/NoMatches.vue";

export default {

	components: {
		NoMatches,
		Button,
		Loading,
		ListItem,
		Pagination,
	},

	props: {
		jobProfileListItem: {
			type: Object,
			required: true,
		},
		filter: {
			type: Object,
			required: false,
		},
		onlyFavorites: {
			type: Boolean,
			required: false,
			default: false
		},
	},

	mounted ()
	{
		this.loadApplicants();
	},

	data ()
	{
		return {
			itemsPerPage: 10,
			page: 1,
			permissions: null,
			applicants: null,
			meta: null,
			loadingApplicants: true
		};
	},

	methods: {
		async loadApplicants ()
		{
			this.$emit('loading');

			this.loadingApplicants = true;

			const getList = new GetList()
				.setJobProfileId(this.jobProfileListItem.jobProfile.id)
				.setOnlyFavorites(this.onlyFavorites)
				.setOffset((this.page - 1) * this.itemsPerPage)
				.setLimit(this.itemsPerPage);

			/*if (this.filter?.groupOnly)
			{
				getList.setGroupOnly(this.filter.groupOnly);
			}

			if (this.filter?.fuzzyType)
			{
				getList.setFuzzyType(this.filter.fuzzyType);
			}*/

			if (this.filter?.filterGroups && arrayIsNotEmpty(this.filter.filterGroups))
			{
				getList.setFilterGroups(this.filter.filterGroups);
			}

			const response = await getList.call();

			this.permissions = response.data.permissions;
			this.applicants = response.data.applicants;
			this.meta = response.meta;

			if (this.meta.total === 0)
			{
				this.$emit('noResults');
			}

			this.loadingApplicants = false;
		},
	},

	watch: {
		onlyFavorites ()
		{
			this.page = 1;

			this.loadApplicants();
		},
		filter ()
		{
			this.page = 1;

			this.loadApplicants();
		},
	}
}
</script>
